import React from 'react';

const purposes = [
  {
    num: '01',
    title: 'Tjenestelevering',
    desc: 'Beregning av bompenger, ruteplanlegging, kjøretøyadministrasjon og abonnementshåndtering.',
    basis: 'Art. 6(1)(b)'
  },
  {
    num: '02',
    title: 'Kundeservice',
    desc: 'Behandling av henvendelser, teknisk support og kommunikasjon om din konto.',
    basis: 'Art. 6(1)(b)'
  },
  {
    num: '03',
    title: 'Fakturering & Betaling',
    desc: 'Prosessering av abonnementsbetalinger, utstedelse av fakturaer og håndtering av refusjoner.',
    basis: 'Art. 6(1)(b)'
  },
  {
    num: '04',
    title: 'Produktforbedring',
    desc: 'Analyse av bruksmønstre for å forbedre tjenestene, feilsøking og utvikling av nye funksjoner.',
    basis: 'Art. 6(1)(f)'
  },
  {
    num: '05',
    title: 'Markedsføring',
    desc: 'Sending av nyhetsbrev, produktoppdateringer og relevante tilbud — kun med ditt samtykke.',
    basis: 'Art. 6(1)(a)'
  },
  {
    num: '06',
    title: 'Lovpålagte forpliktelser',
    desc: 'Oppfyllelse av regnskapsloven, skattelovgivning og andre norske lovkrav.',
    basis: 'Art. 6(1)(c)'
  },
];

const PurposeSection = () => {
  return (
    <section id="formal" style={{ marginBottom: '80px' }}>
      <div style={{ marginBottom: '40px', position: 'relative' }}>
        <div
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: 'clamp(4rem, 10vw, 8rem)',
            fontWeight: 900,
            color: 'rgba(249,115,22,0.05)',
            lineHeight: 1,
            position: 'absolute',
            top: '-20px',
            left: '-10px',
            userSelect: 'none',
            letterSpacing: '-0.04em'
          }}
        >
          02
        </div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#F97316',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '8px'
            }}
          >
            § 2 — FORMÅL
          </div>
          <h2
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(1.75rem, 4vw, 3rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              textTransform: 'uppercase',
              letterSpacing: '-0.02em',
              lineHeight: 1
            }}
          >
            Formål med behandlingen
          </h2>
        </div>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '20px'
        }}
      >
        {purposes?.map((p) => (
          <div
            key={p?.num}
            style={{
              background: 'rgba(255,255,255,0.02)',
              border: '1px solid rgba(255,255,255,0.06)',
              padding: '24px',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '-10px',
                right: '-5px',
                fontFamily: 'Impact, sans-serif',
                fontSize: '5rem',
                fontWeight: 900,
                color: 'rgba(255,255,255,0.03)',
                lineHeight: 1,
                userSelect: 'none'
              }}
            >
              {p?.num}
            </div>
            <div
              style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '1rem',
                fontWeight: 700,
                color: '#EEF0F2',
                marginBottom: '10px'
              }}
            >
              {p?.title}
            </div>
            <p
              style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.875rem',
                color: 'rgba(138,149,163,0.8)',
                lineHeight: 1.6,
                marginBottom: '14px'
              }}
            >
              {p?.desc}
            </p>
            <div
              style={{
                display: 'inline-block',
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.625rem',
                color: '#3B6FD4',
                background: 'rgba(59,111,212,0.1)',
                border: '1px solid rgba(59,111,212,0.2)',
                padding: '3px 8px',
                letterSpacing: '0.08em'
              }}
            >
              GDPR {p?.basis}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PurposeSection;
